<template>
  <div :class="pageAsideClasses">
    <AppSidebar />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import AppSidebar from '@/app/sidebar/app-sidebar';

export default defineComponent({
  name: 'PageAside',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      isSidebarActive: 'layout/isSidebarActive',
    }),

    pageAsideClasses() {
      return ['page-aside', { open: this.isSidebarActive }];
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    AppSidebar,
  },
});
</script>

<style scoped></style>
